export default "__VITE_ASSET__zyJVRl5o__"